var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "teenyicons:password-outline",
    clipPath: "url(#clip0_755_613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6667 11.3333V9.99996C16.6667 9.64634 16.5263 9.3072 16.2762 9.05715C16.0262 8.8071 15.687 8.66663 15.3334 8.66663H2.00008C1.64646 8.66663 1.30732 8.8071 1.05727 9.05715C0.807224 9.3072 0.666748 9.64634 0.666748 9.99996V18C0.666748 18.3536 0.807224 18.6927 1.05727 18.9428C1.30732 19.1928 1.64646 19.3333 2.00008 19.3333H15.3334C15.687 19.3333 16.0262 19.1928 16.2762 18.9428C16.5263 18.6927 16.6667 18.3536 16.6667 18V16.6666M16.6667 11.3333H11.3334C10.6262 11.3333 9.94789 11.6142 9.4478 12.1143C8.9477 12.6144 8.66675 13.2927 8.66675 14C8.66675 14.7072 8.9477 15.3855 9.4478 15.8856C9.94789 16.3857 10.6262 16.6666 11.3334 16.6666H16.6667M16.6667 11.3333C17.374 11.3333 18.0523 11.6142 18.5524 12.1143C19.0525 12.6144 19.3334 13.2927 19.3334 14C19.3334 14.7072 19.0525 15.3855 18.5524 15.8856C18.0523 16.3857 17.374 16.6666 16.6667 16.6666M4.66675 8.66663V4.66663C4.66675 3.60576 5.08818 2.58834 5.83832 1.8382C6.58847 1.08805 7.60588 0.666626 8.66675 0.666626C9.72761 0.666626 10.745 1.08805 11.4952 1.8382C12.2453 2.58834 12.6667 3.60576 12.6667 4.66663V8.66663M16.0001 14H17.3334M13.3334 14H14.6667M10.6667 14H12.0001",
    stroke: "#717171",
    strokeWidth: 1.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_755_613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.fcde35806bb9067c3c24598435f6d603.svg";
export { ForwardRef as ReactComponent };